import { createSelector } from 'reselect';
import { getBandsPosition } from '../../Utils/LayoutUtils';
import {
  selectCalculatedDisplayMode,
  selectFusedDataColumns,
} from '../../../reducers/layoutReducer/displayModel';

export const isNonStackOrFirstInStack = (displayMode, index) => {
  const mode = displayMode?.[index];
  if (mode !== 'stack' && mode !== 'stackcard') return true; // not a stack -> true
  return (
    index === 0 ||
    (displayMode[index - 1] !== 'stack' &&
      displayMode[index - 1] !== 'stackcard')
  ); // first in a stack run
};

export const getRangeHeaderWidth2 = (columns = []) =>
  Array.isArray(columns) ? columns.reduce((acc, c) => acc + (c?.w ?? 0), 0) : 0;

export const makeIsLevelCardUnderStack = () =>
  createSelector(
    [(s, index) => index, selectCalculatedDisplayMode],
    (index, mask) =>
      index >= 1 &&
      (mask?.[index] === 'card' || mask?.[index] === 'stackcard') &&
      (mask?.[index - 1] === 'stack' || mask?.[index - 1] === 'stackcard')
  );

// 5) “out of stack” : compare positions (panels) et largeur des colonnes du level précédent
export const makeSelectIsOutOfStack = () =>
  createSelector(
    [
      (s, index) => index,
      selectFusedDataColumns,
      (s) => s.objects?.panels ?? [],
    ],
    (index, fused, panels) => {
      if (index < 1) return true;
      const prevWidth = getRangeHeaderWidth2(fused?.[index - 1] ?? []);
      const prevStart = getBandsPosition(index - 1, panels).start;
      const currStart = getBandsPosition(index, panels).start;
      const minPos = prevWidth + prevStart;
      return currStart > minPos;
    }
  );

// 6) afficher le header “card top” ?
// règle: !isLevelCardUnderStack(index) || isOutOfStack(index)
export const makeSelectShouldDisplayCardTopHeader = () => {
  const selCardUnderStack = makeIsLevelCardUnderStack();
  const selOutOfStack = makeSelectIsOutOfStack();
  return createSelector(
    [(s, index) => index, selCardUnderStack, selOutOfStack],
    (index, isUnder, outOf) => !isUnder || outOf
  );
};
